const LoadingFallback = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <style>{`
        @keyframes netflix-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div
        style={{
          width: 48,
          height: 48,
          border: '4px solid #fce4ec',
          borderTop: '4px solid #C46070',
          borderRadius: '50%',
          animation: 'netflix-spin 0.8s linear infinite',
        }}
      />
    </div>
  );
};

export default LoadingFallback;